export default __webpack_public_path__ + "static/media/spotify-sqr.9f5ec5fc.svg";